import { PageHeader } from '@/components/PageHeader';
import { PeopleTable } from './PeopleTable';

export function UsersAgentsPage() {
  return <>
    <PageHeader title="People" description="Account identity, unfinished leads and agent authorization." />
    <div className="px-8 py-6"><PeopleTable /></div>
  </>;
}
